import Vue from 'vue'
import Router from 'vue-router'
import Split from '@/components/Split'
import Welcome from '@/components/Welcome'

const NotFound = { template: '<p>Page not found</p>' }

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      /* Once there are multiple sports, this path will be '/'.
         Links from this page will redirect to the homepage. */
      path: '/',
      name: 'Welcome',
      component: Welcome,
      redirect: {
        name: 'Diving'
      }
    },
    {
      path: '/diving',
      name: 'Diving',
      component: Split,
      meta: {
        sport: 'diving'
      },
    },
    {
      path: '/weightlifting',
      name: 'Weightlifting',
      component: Split,
      meta: {
        sport: 'weightlifting'
      },
      redirect: {
        name: 'Diving'
      }
    },
    {
      path: '/wl',
      redirect: {
        // name: 'Weightlifting'
        name: 'Diving'
      }
    }
  ],
  data: {
    currentRoute: window.location.pathname
  },
  computed: {
    ViewComponent() {
      return routes[this.currentRoute] || NotFound
    }
  },
  render (h) {
    return h(this.ViewComponent)
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js